import Cookies from 'js-cookie';
import axios from 'axios';
import { getPardotVisitorId, getUrlVars } from './demoFormUrlUtilities';
import { getUTMs } from '../../../utils/handleCookies';
import { sendToPardotForm } from './pardotIframe';

const SERVER_DEMO_ENDPOINT = 'https://upkeep-server.herokuapp.com/pardot/demo';
const NEWSLETTER_SCHEDULE_ENDPOINT =
  'https://upkeep-server.herokuapp.com/pardot/newsletter';
const FREE_TRIAL_ENDPOINT =
  'https://upkeep-server.herokuapp.com/pardot/free-trial';
const GATED_CONTENT_ENDPOINT =
  'https://upkeep-server.herokuapp.com/pardot/gated_content';
const EDGE_CONTACT_FORM =
  'https://upkeep-server.herokuapp.com/pardot/edge_pricing';
const STARTER_SUBSCRIPTION_ENDPOINT =
  'https://upkeep-server.herokuapp.com/pardot/starter_subscription';

export default class PardotFormApi {
  static signUp(demo, formHandler) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUTMs();
    const visitorId = { visitor_id: getPardotVisitorId() };

    sendToPardotForm({
      formHandler,
      formType: 'DEMO',
      payload: demo,
      params,
    });
    return axios.post(SERVER_DEMO_ENDPOINT, {
      ...params,
      ...demo,
      ...visitorId,
    });
  }

  static demoChiliPiper(demo, formHandler) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUTMs();

    sendToPardotForm({
      formHandler,
      formType: 'DEMO_CHILIPIPER',
      payload: demo,
      params,
    });
    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
  }

  static newsletterSignUp(email) {
    Cookies.set('uk_email', email);

    const params = getUTMs();

    sendToPardotForm({
      formType: 'NEWSLETTER',
      payload: { email },
      params,
    });
    return axios.post(NEWSLETTER_SCHEDULE_ENDPOINT, {
      email,
      visitor_id: getPardotVisitorId(),
    });
  }

  static newsletterSignUpList(email) {
    Cookies.set('uk_email', email);

    const params = getUTMs();

    sendToPardotForm({
      formType: 'NEWSLETTER_SIGNUP_LIST',
      payload: { email },
      params,
    });

    return axios.post(NEWSLETTER_SCHEDULE_ENDPOINT, {
      email,
      visitor_id: getPardotVisitorId(),
    });
  }

  static freeTrialSignup(demo) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUTMs();
    const visitorId = { visitor_id: getPardotVisitorId() };

    sendToPardotForm({
      formType: 'FREE_TRIAL',
      payload: demo,
      params,
    });
    return axios.post(FREE_TRIAL_ENDPOINT, {
      ...params,
      ...demo,
      ...visitorId,
    });
  }

  static freeTrialSignupSales(demo) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUTMs();
    const visitorId = { visitor_id: getPardotVisitorId() };

    sendToPardotForm({
      formType: 'FREE_TRIAL_SALES',
      payload: demo,
      params,
    });
    return axios.post(FREE_TRIAL_ENDPOINT, {
      ...params,
      ...demo,
      ...visitorId,
    });
  }

  static gatedContent(demo, handler) {
    Cookies.set('up_email', demo.email);
    const params = getUTMs();

    sendToPardotForm({
      formHandler: handler,
      formType: 'GATED_CONTENT',
      payload: demo,
      params,
    });
    return axios.post(GATED_CONTENT_ENDPOINT, { ...demo });
  }

  static edgeContact(demo) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUTMs();
    const visitorId = { visitor_id: getPardotVisitorId() };

    sendToPardotForm({
      formType: 'EDGE_CONTACT',
      payload: demo,
      params,
    });
    return axios.post(EDGE_CONTACT_FORM, {
      ...params,
      ...demo,
      ...visitorId,
    });
  }

  static testForm(demo) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUTMs();

    sendToPardotForm({
      formType: 'TEST',
      payload: demo,
      params,
    });
  }

  static exitIntent(demo, formHandler) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUTMs();
    sendToPardotForm({
      formHandler,
      formType: 'EXIT_INTENT',
      payload: demo,
      params,
    });
  }

  static starterSubscription(demo) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUTMs();
    const visitorId = { visitor_id: getPardotVisitorId() };

    sendToPardotForm({
      formType: 'STARTER_SUBSCRIPTION',
      payload: demo,
      params,
    });
    return axios.post(STARTER_SUBSCRIPTION_ENDPOINT, {
      ...params,
      ...demo,
      ...visitorId,
    });
  }

  static requestPricing(demo) {
    const params = getUTMs();

    for (const field in params) {
      Cookies.set(field, params[field]);
    }

    sendToPardotForm({
      formType: 'REQUEST_PRICING',
      payload: demo,
      params,
    });
    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
  }

  static partnerSignup(demo) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUTMs();

    sendToPardotForm({
      formType: 'PARTNER_SIGNUP',
      payload: demo,
      params,
    });
    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
  }

  static bookContest(demo, formHandler) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUrlVars();
    for (const field in params) {
      Cookies.set(field, params[field]);
    }

    sendToPardotForm({
      formHandler,
      formType: 'BOOK_CONTEST',
      payload: demo,
      params,
    });
    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
  }

  static tshirtGiveaway(data, formHandler) {
    Cookies.set('uk_user_data', JSON.stringify(data));
    localStorage.setItem('uk_user_data', JSON.stringify(data));

    const params = getUrlVars();
    for (const field in params) {
      Cookies.set(field, params[field]);
    }

    sendToPardotForm({
      formHandler,
      formType: 'TSHIRT_GIVEAWAY',
      payload: data,
      params,
    });
    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
  }

  static demoCmmsRadio(demo, formHandler) {
    Cookies.set('uk_user_data', JSON.stringify(demo));
    localStorage.setItem('uk_user_data', JSON.stringify(demo));

    const params = getUTMs();

    sendToPardotForm({
      formHandler,
      formType: 'DEMO_CMMMS_RADIO',
      payload: demo,
      params,
    });
    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
  }

  static maintanenceAppreciation(demo, formHandler) {
    const params = getUTMs();

    for (const field in params) {
      Cookies.set(field, params[field]);
    }

    sendToPardotForm({
      formHandler,
      formType: 'MAINTENANCE_APPRECIATION',
      payload: demo,
      params,
    });
    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
  }

  static aiIntelligenceForm(data, formHandler) {
    Cookies.set('uk_user_data', JSON.stringify(data));
    localStorage.setItem('uk_user_data', JSON.stringify(data));

    const params = getUTMs();
    for (const field in params) {
      Cookies.set(field, params[field]);
    }

    sendToPardotForm({
      formHandler,
      formType: 'AI_INTELLIGENCE',
      payload: data,
      params,
    });
    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
  }

  static aiGeneratorForm(data) {
    Cookies.set('uk_user_data', JSON.stringify(data));
    localStorage.setItem('uk_user_data', JSON.stringify(data));

    const params = getUTMs();
    for (const field in params) {
      Cookies.set(field, params[field]);
    }

    sendToPardotForm({
      formType: 'AI_GENERATOR',
      payload: data,
      params,
    });

    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
  }

  static ehsForm(data, formHandler) {
    Cookies.set('uk_user_data', JSON.stringify(data));
    localStorage.setItem('uk_user_data', JSON.stringify(data));

    const params = getUTMs();
    for (const field in params) {
      Cookies.set(field, params[field]);
    }

    sendToPardotForm({
      formHandler,
      formType: 'EHS_FORM',
      payload: data,
      params,
    });
    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
  }
}
